(function () {
  var root = document.querySelector('[data-npd-product]');
  if (!root) return;

  // Reloads start at the top: browser scroll restoration + late-loading app
  // blocks were landing users partway down the page (per Shane).
  try {
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'reload' && !location.hash) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      window.scrollTo(0, 0);
    }
  } catch (e) { /* non-critical */ }

  // ── Gallery dots + bidirectional infinite loop (mobile swipe deck) ──
  // On mobile the deck is [cloneLast, real0..realN-1, cloneFirst]. Reaching a
  // clone silently repositions to the identical real frame, so the deck loops
  // BOTH ways with no dead-end. The reposition briefly turns off scroll-snap
  // and sets scrollLeft directly (not scrollTo) — the snap-toggle is what keeps
  // iOS from fighting the jump and freezing further swipes.
  var gal = root.querySelector('[data-npd-gallery]');
  var dots = root.querySelector('[data-npd-dots]');
  if (gal && dots && gal.children.length > 1) {
    var mq = window.matchMedia('(max-width: 749px)');
    var realTotal = gal.children.length;
    var headClone = null; // clone of last frame, prepended
    var tailClone = null; // clone of first frame, appended
    var looped = false;

    dots.innerHTML = Array.from({ length: realTotal }, function () { return '<span></span>'; }).join('');
    var marks = Array.prototype.slice.call(dots.children);

    function jumpTo(idx) {
      var prev = gal.style.scrollSnapType;
      gal.style.scrollSnapType = 'none';
      // exact frame offset, not idx*clientWidth: fractional layouts (390/430pt
      // iPhones) park the deck off its snap point with the integer math, and
      // iOS treats a touch on an off-snap deck as "this scroller needs me" —
      // capturing gestures meant for vertical page scroll
      var f = gal.children[idx];
      gal.scrollLeft = f ? f.offsetLeft : idx * gal.clientWidth;
      // force reflow so the position lands before snap re-engages
      void gal.offsetWidth;
      gal.style.scrollSnapType = prev || '';
    }

    function buildLoop() {
      if (mq.matches && !looped) {
        // real last frame cloned to the start, real first frame cloned to the end
        headClone = gal.children[realTotal - 1].cloneNode(true);
        tailClone = gal.children[0].cloneNode(true);
        headClone.setAttribute('aria-hidden', 'true');
        tailClone.setAttribute('aria-hidden', 'true');
        gal.insertBefore(headClone, gal.firstElementChild);
        gal.appendChild(tailClone);
        looped = true;
        // start on the first REAL frame (index 1)
        jumpTo(1);
      } else if (!mq.matches && looped) {
        if (headClone) headClone.remove();
        if (tailClone) tailClone.remove();
        headClone = tailClone = null;
        looped = false;
        gal.scrollLeft = 0;
      }
    }

    var settleTimer = null;
    function sync() {
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      if (looped) {
        // real frames occupy indices 1..realTotal; map to dot 0..realTotal-1
        var realIdx = ((i - 1) % realTotal + realTotal) % realTotal;
        marks.forEach(function (m, k) { m.classList.toggle('on', k === realIdx); });
      } else {
        marks.forEach(function (m, k) { m.classList.toggle('on', k === i % realTotal); });
      }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (!looped) return;
        var idx = Math.round(gal.scrollLeft / gal.clientWidth);
        if (idx <= 0) {
          jumpTo(realTotal);          // on head clone (last) → real last frame
        } else if (idx >= realTotal + 1) {
          jumpTo(1);                  // on tail clone (first) → real first frame
        }
      }, 80);
    }

    // Lazy frames blank out mid-swipe (horizontal scrollers get no lazy
    // prefetch margin) — warm the whole deck once the browser is idle, or
    // instantly on first touch, so every frame is fetched before it's seen.
    var warmed = false;
    function warmDeck() {
      if (warmed) return;
      warmed = true;
      gal.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.removeAttribute('loading');
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warmDeck, { timeout: 2500 });
    else setTimeout(warmDeck, 1500);
    gal.addEventListener('touchstart', warmDeck, { passive: true, once: true });

    buildLoop();
    sync();
    gal.addEventListener('scroll', sync, { passive: true });
    // scrollend (iOS 16+/modern) gives a reliable settle signal alongside the timer
    gal.addEventListener('scrollend', function () {
      if (!looped) return;
      var idx = Math.round(gal.scrollLeft / gal.clientWidth);
      if (idx <= 0) jumpTo(realTotal);
      else if (idx >= realTotal + 1) jumpTo(1);
    });
    // A deck parked on a clone still owes a reposition; if the finger lands
    // before the settle timer fires, iOS captures the gesture for the deck and
    // a vertical page-scroll flick reads as a horizontal image drag. Settle
    // the debt synchronously at touchstart, ahead of gesture arbitration.
    gal.addEventListener('touchstart', function () {
      if (!looped) return;
      var idx = Math.round(gal.scrollLeft / gal.clientWidth);
      if (idx <= 0) jumpTo(realTotal);
      else if (idx >= realTotal + 1) jumpTo(1);
    }, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', buildLoop);

    // Desktop split-scroll (Meshki pattern): the gallery wrap is its own
    // scroll container; the ink dots track its vertical progress. Mobile
    // keeps the horizontal deck's own dot logic in sync() above.
    var wrap = root.querySelector('.npd-gallery-wrap');
    if (wrap) {
      var syncDesktopDots = function () {
        if (mq.matches) { dots.style.marginTop = ''; return; }
        // exact flow-height cancellation: dot count varies per product
        dots.style.marginTop = -(dots.offsetHeight) + 'px';
        var range = wrap.scrollHeight - wrap.clientHeight;
        var idx = range > 2 ? Math.round(wrap.scrollTop / range * (realTotal - 1)) : 0;
        marks.forEach(function (m, k) { m.classList.toggle('on', k === idx); });
      };
      wrap.addEventListener('scroll', syncDesktopDots, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', syncDesktopDots);
      syncDesktopDots();
    }
  }

  // ── Variant state ──
  var variantsEl = root.querySelector('[data-npd-variants]');
  var configEl = root.querySelector('[data-npd-config]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var config = configEl ? JSON.parse(configEl.textContent) : { colorIndex: -1, sizeIndex: -1, lengthIndex: -1 };
  if (config.lengthIndex === undefined) config.lengthIndex = -1;
  var colorName = root.querySelector('[data-npd-color-name]');
  var sizeName = root.querySelector('[data-npd-size-name]');
  var lengthName = root.querySelector('[data-npd-length-name]');
  // length value -> inseam (e.g. {"regular":"30\"","tall":"32\""}); empty when
  // the product documents no per-length figure, and we then show the name
  var INSEAMS = (function () {
    var el = root.querySelector('[data-npd-inseams]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  })();
  function lengthLabel(v) {
    if (!v) return v;
    var hit = INSEAMS[String(v).trim().toLowerCase()];
    return hit ? hit + ' inseam' : v;
  }
  var priceEl = root.querySelector('[data-npd-price]');
  var wasEl = root.querySelector('[data-npd-was]');
  var variantInput = root.querySelector('[data-npd-variant-id]');
  var addBtn = root.querySelector('[data-npd-add]');

  // Sticky bar. It is a SIBLING of [data-npd-product] (fixed positioning must
  // not sit under a transformed ancestor), so these query document, not root.
  var sab = document.querySelector('[data-npd-sab]');
  var sabPriceEl = document.querySelector('[data-npd-sab-price]');
  var sabWasEl = document.querySelector('[data-npd-sab-was]');
  var sabCta = document.querySelector('[data-npd-sab-cta]');

  function sizeChips() {
    return root.querySelectorAll('[data-npd-sizes] .npd-size');
  }

  var state = {
    color: colorName ? colorName.textContent.trim() : null,
    // Read the chip's data-value, not the label text: the label is a rendered
    // string (and the length label renders an inseam, not the option name), so
    // the chip is the only faithful source for the option value.
    size: (function () {
      var chip = root.querySelector('[data-npd-sizes] .npd-size.active');
      return chip ? chip.getAttribute('data-value') : (sizeName ? sizeName.textContent.trim() : null);
    })(),
    length: (function () {
      var chip = root.querySelector('[data-npd-lengths] .npd-size.active');
      return chip ? chip.getAttribute('data-value') : null;
    })()
  };

  function findVariant() {
    return variants.find(function (v) {
      var okColor = config.colorIndex < 0 || v.options[config.colorIndex] === state.color;
      var okSize = config.sizeIndex < 0 || v.options[config.sizeIndex] === state.size;
      var okLength = config.lengthIndex < 0 || v.options[config.lengthIndex] === state.length;
      return okColor && okSize && okLength;
    });
  }

  function sizeAvailable(size) {
    return variants.some(function (v) {
      var okColor = config.colorIndex < 0 || v.options[config.colorIndex] === state.color;
      var okLength = config.lengthIndex < 0 || v.options[config.lengthIndex] === state.length;
      return okColor && okLength && v.options[config.sizeIndex] === size && v.available;
    });
  }

  function lengthAvailable(len) {
    return variants.some(function (v) {
      var okColor = config.colorIndex < 0 || v.options[config.colorIndex] === state.color;
      return okColor && v.options[config.lengthIndex] === len && v.available;
    });
  }

  function updateUI() {
    var v = findVariant();
    if (colorName && state.color) colorName.textContent = state.color;
    if (sizeName && state.size) sizeName.textContent = state.size;
    if (config.sizeIndex > -1) {
      // covers the in-page selector AND the sticky bar's mirror of it
      sizeChips().forEach(function (b) {
        b.disabled = !sizeAvailable(b.dataset.value);
      });
    }
    if (config.lengthIndex > -1) {
      if (lengthName && state.length) lengthName.textContent = lengthLabel(state.length);
      root.querySelectorAll('[data-npd-lengths] .npd-size').forEach(function (b) {
        b.disabled = !lengthAvailable(b.dataset.value);
      });
    }
    if (v) {
      // innerHTML, not textContent: money_without_trailing_zeros emits a
      // <span class=money> wrapper (currency conversion hooks onto it), so
      // textContent would print the raw markup on every variant change.
      if (priceEl) priceEl.innerHTML = v.price;
      if (sabPriceEl) sabPriceEl.innerHTML = v.price;
      // compare-at follows the variant (sale price shows a struck original)
      if (wasEl) {
        if (v.compare_at) { wasEl.innerHTML = v.compare_at; wasEl.hidden = false; }
        else { wasEl.innerHTML = ''; wasEl.hidden = true; }
      }
      if (sabWasEl) {
        if (v.compare_at) { sabWasEl.innerHTML = v.compare_at; sabWasEl.hidden = false; }
        else { sabWasEl.innerHTML = ''; sabWasEl.hidden = true; }
      }
      if (variantInput) variantInput.value = v.id;
      setAddState(v.available ? 'Add to Cart' : 'Sold Out', !v.available);
    } else {
      setAddState('Unavailable', true);
    }
  }

  // Both CTAs mirror the variant label, but only the real one is ever disabled:
  // the sticky CTA just scrolls, and a shopper whose selected size sold out
  // needs it MORE, not less — that tap is how they get back up to pick another.
  // Skipped while mid-add so updateUI() can't stomp 'Adding…'/'Added ✓'.
  function setAddState(label, disabled) {
    if (addBtn && !addBtn.classList.contains('adding') && !addBtn.classList.contains('added')) {
      addBtn.disabled = disabled;
      addBtn.textContent = label;
    }
    if (sabCta) sabCta.textContent = label;
  }

  root.querySelectorAll('[data-npd-colors] .npd-swatch').forEach(function (s) {
    s.addEventListener('click', function () {
      root.querySelectorAll('[data-npd-colors] .npd-swatch').forEach(function (x) { x.classList.remove('active'); });
      s.classList.add('active');
      state.color = s.dataset.value;
      updateUI();
    });
  });

  root.querySelectorAll('[data-npd-lengths] .npd-size').forEach(function (s) {
    s.addEventListener('click', function () {
      root.querySelectorAll('[data-npd-lengths] .npd-size').forEach(function (x) { x.classList.remove('active'); });
      s.classList.add('active');
      state.length = s.dataset.value;
      updateUI();
    });
  });

  // Has the shopper actually CHOSEN a size, or are they still sitting on the
  // pre-selected default? The two are indistinguishable in the markup, so we
  // track the choice. Nothing to choose on a product with no size axis, and a
  // ?variant= link already named one, so both count as chosen.
  var sizeChosen = config.sizeIndex < 0 || /[?&]variant=/.test(window.location.search);
  var sizePrompt = root.querySelector('[data-npd-size-prompt]');
  var sizeRow = root.querySelector('[data-npd-sizes]');

  function markNeedSize(on) {
    if (sizeRow) sizeRow.classList.toggle('npd-need-size', on);
    if (sizePrompt) sizePrompt.hidden = !on;
  }

  function setSize(value) {
    state.size = value;
    sizeChosen = true;
    markNeedSize(false);
    sizeChips().forEach(function (x) {
      x.classList.toggle('active', x.dataset.value === value);
    });
    updateUI();
  }

  sizeChips().forEach(function (s) {
    s.addEventListener('click', function () { setSize(s.dataset.value); });
  });

  // ── Ajax add to cart, into the theme's cart drawer ──
  function refreshCart() {
    try {
      if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
        if (typeof window.PXUTheme.jsAjaxCart.updateView === 'function') window.PXUTheme.jsAjaxCart.updateView();
        if (typeof window.PXUTheme.jsAjaxCart.showDrawer === 'function') window.PXUTheme.jsAjaxCart.showDrawer();
      }
    } catch (e) { /* cart still updated server-side */ }
  }

  function ajaxAdd(variantId, button, restLabel) {
    if (button.classList.contains('adding')) return Promise.resolve(); // no double-adds
    button.disabled = true;
    button.classList.add('adding');
    button.textContent = 'Adding';
    function settle(label, cls) {
      button.classList.remove('adding');
      if (cls) button.classList.add(cls);
      button.textContent = label;
      setTimeout(function () {
        button.textContent = restLabel;
        if (cls) button.classList.remove(cls);
        button.disabled = false;
      }, 1600);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      settle('Added ✓', 'added');
      refreshCart();
    }).catch(function () {
      settle('Try again');
    });
  }

  var form = root.querySelector('[data-npd-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || addBtn.disabled) return;
      ajaxAdd(variantInput.value, addBtn, 'Add to Cart');
    });
  }

  // ── Sticky bar CTA: scroll back to the buy block, don't add ──
  // Shane 2026-08-08 (Alo's pattern): sending shoppers back to the real
  // selector converts better than a bar that adds whatever size happens to be
  // pre-selected, and it keeps returns down. The size row briefly flashes so
  // the jump reads as "choose here" rather than an unexplained scroll.
  //
  // Note reviews.js wraps window.scrollTo, but it only swallows calls whose
  // stack comes from Judge.me's bundle — this one passes through natively.
  if (sabCta) {
    sabCta.addEventListener('click', function () {
      // Size already confirmed and in stock: the bar behaves as it reads and
      // adds, with the cart drawer opening as unmistakable feedback.
      var v = findVariant();
      if (sizeChosen && v && v.available) {
        if (!variantInput) return;
        ajaxAdd(variantInput.value, sabCta, 'Add to Cart');
        return;
      }
      // Otherwise the label would be writing a cheque the click can't cash, so
      // send them to the selector and say why. Same path when the selected size
      // is sold out — they need to pick another one.
      markNeedSize(true);
      // Anchor on the product head (fabric → title → price), not the option
      // rows: landing on the swatches left the title off-screen and the buy
      // block read as a fragment. Shane 2026-08-08 — scroll a bit further up.
      var target = root.querySelector('.npd-head') || sizeRow || form;
      if (!target) return;
      var HEADER = 76; // .nmd-header is fixed at this height
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = window.scrollY + target.getBoundingClientRect().top - HEADER - 28;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  // The desktop bar hangs off the bottom of the header, and that height is NOT
  // a constant: #header is 67px in flow, then Flex's header-sticky-wrapper
  // re-homes it as position:fixed at 57px once stuck (and the 28px announcement
  // bar scrolls away with it). Hardcoding an offset left a visible gap, so read
  // the real rect and hand it to CSS. Mobile ignores the variable entirely.
  var sabHeader = document.querySelector('.nmd-header');
  var sabRaf = null;
  var sabLastTop = null;

  // Just the header's bottom edge, clamped at 0 — right in every state: pinned
  // -> its stuck height, scrolled away -> negative so 0, in flow -> below it.
  // Writes only on change, so the frame loop below doesn't invalidate style 60x
  // a second for nothing.
  function syncSabTop() {
    if (!sab || !sabHeader) return;
    // Keep the subpixel value: rounding to whole px left a ~0.5px seam of page
    // content between nav and bar on fractional layouts / 2x displays.
    var bottom = sabHeader.getBoundingClientRect().bottom;
    var top = bottom > 0 ? bottom : 0;
    if (sabLastTop !== null && Math.abs(top - sabLastTop) < 0.25) return;
    sabLastTop = top;
    sab.style.setProperty('--npd-sab-top', top + 'px');
  }

  // Track per-frame while the bar is on screen, rather than trying to enumerate
  // the events that move the nav. Three separate attempts at event-chasing all
  // left a stale offset — the nav changes POSITION without changing size (in
  // flow -> fixed, so ResizeObserver stays quiet) and changes SIZE after
  // scrolling has stopped (padding 21px -> 16px, so scroll events have already
  // fired). One rect read per frame, only on desktop, only while visible, and
  // it self-heals no matter what the theme does to the header.
  function trackSabTop(on) {
    if (on) {
      if (sabRaf !== null) return;
      (function loop() { sabRaf = requestAnimationFrame(loop); syncSabTop(); })();
    } else if (sabRaf !== null) {
      cancelAnimationFrame(sabRaf);
      sabRaf = null;
    }
  }

  // Reveal only once the real Add to Cart has scrolled off the TOP —
  // boundingClientRect.top < 0 distinguishes that from "not reached yet", so
  // the bar never covers the gallery at first paint. Same shape as the creator
  // landing page's sticky CTA. An observer (rather than a scroll delta) also
  // rides out Judge.me's three programmatic scroll paths without flickering.
  if (sab && form && 'IntersectionObserver' in window) {
    // Scroll and resize sync DIRECTLY — no rAF gate. It's one rect read plus a
    // conditional write, and scroll already coalesces to a frame, so throttling
    // bought nothing while making the offset stale whenever rAF was starved.
    window.addEventListener('scroll', syncSabTop, { passive: true });
    window.addEventListener('resize', syncSabTop, { passive: true });

    // The offset only exists on the desktop/tablet top-anchored bar; the mobile
    // bar is bottom-anchored and ignores the variable, so don't burn frames.
    var sabDesktop = window.matchMedia('(min-width: 750px)');
    var sabShown = false;
    function applySabTracking() {
      trackSabTop(sabShown && sabDesktop.matches);
    }
    if (sabDesktop.addEventListener) sabDesktop.addEventListener('change', applySabTracking);

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sabShown = !e.isIntersecting && e.boundingClientRect.top < 0;
      syncSabTop();          // correct before the slide starts, not during it
      applySabTracking();    // then keep it correct for as long as it's up
      sab.classList.toggle('on', sabShown);
    }, { threshold: 0 }).observe(form);

    syncSabTop();
  }

  // ── Accordions ──
  root.querySelectorAll('.npd-acc-head').forEach(function (h) {
    h.addEventListener('click', function () {
      var acc = h.parentElement;
      var open = acc.classList.toggle('open');
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
      h.querySelector('.npd-acc-ico').textContent = open ? '–' : '+';
      // When the sticky info column is PARKED at its container bottom
      // (user scrolled past its range), sticky pins the bottom edge and
      // the panel growth shoves the whole column — and this header —
      // upward ("opens upward", Shane). Hold the tapped header visually
      // stationary through the 300ms max-height transition; in the
      // normal state the header doesn't move and this is a no-op.
      var holdTop = h.getBoundingClientRect().top;
      var holdT0 = performance.now();
      (function hold() {
        var d = h.getBoundingClientRect().top - holdTop;
        if (d > 0.5 || d < -0.5) window.scrollBy(0, d);
        if (performance.now() - holdT0 < 380) requestAnimationFrame(hold);
      })();
    });
  });

  // ── Complete The Set quick add: choosing a size adds to cart ──
  // Hairline Add, expands (Claude Design Option B): the outlined CTA swaps
  // IN PLACE for the size chips; a chip click adds and swaps back with
  // Adding/Added states on the CTA. One-size products add directly.
  root.querySelectorAll('[data-npd-set-dd]').forEach(function (dd) {
    var btn = dd.querySelector('[data-npd-set-toggle]');
    var chips = dd.querySelector('[data-npd-set-menu]');
    var oneSize = dd.dataset.npdOneSize;
    var restLabel = 'Add';
    function collapse() { chips.hidden = true; btn.hidden = false; btn.setAttribute('aria-expanded', 'false'); }
    function expand() {
      document.querySelectorAll('[data-npd-set-dd]').forEach(function (o) {
        if (o !== dd) { o.querySelector('[data-npd-set-menu]').hidden = true; var b = o.querySelector('[data-npd-set-toggle]'); if (!b.classList.contains('adding') && !b.classList.contains('added')) b.hidden = false; }
      });
      btn.hidden = true; chips.hidden = false; btn.setAttribute('aria-expanded', 'true');
    }
    function settle(label, cls) {
      btn.classList.remove('adding');
      if (cls) btn.classList.add(cls);
      btn.textContent = label;
      setTimeout(function () {
        btn.textContent = restLabel;
        if (cls) btn.classList.remove(cls);
        btn.disabled = false;
      }, 1600);
    }
    function add(variantId) {
      collapse();
      btn.disabled = true;
      btn.classList.add('adding');
      btn.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        settle('Added ✓', 'added');
        refreshCart();
      }).catch(function () {
        settle('Try again');
      });
    }
    btn.addEventListener('click', function () {
      if (btn.classList.contains('adding')) return;
      if (oneSize) { add(oneSize); return; }
      expand();
    });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target) && !chips.hidden) collapse(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !chips.hidden) collapse(); });
    chips.querySelectorAll('.npd-set-chip').forEach(function (chip) {
      if (chip.disabled) return;
      chip.addEventListener('click', function () { add(chip.dataset.variantId); });
    });
    // Size+Length: length toggle filters the size chips (quick-add convention)
    var lenBtns = chips.querySelectorAll('.npd-set-len');
    if (lenBtns.length) {
      var applyLen = function (len) {
        lenBtns.forEach(function (b) { b.classList.toggle('active', b.dataset.len === len); });
        chips.querySelectorAll('.npd-set-chip').forEach(function (c) { c.hidden = c.dataset.len !== len; });
      };
      lenBtns.forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); applyLen(b.dataset.len); });
      });
      applyLen(lenBtns[0].dataset.len);
    }
  });

  // ── Rating row: prefer our spec stars (from the reviews.* metafields
  // Judge.me maintains, rendered in Liquid); the Judge.me badge block is
  // removed when they exist, and only relocated into the slot as a fallback.
  var ratingSlot = root.querySelector('[data-npd-rating-slot]');
  if (ratingSlot) {
    var starWidget = root.querySelector('.npd-app-block .jdgm-widget, .npd-app-block [data-id="judgeme-preview-badge"], .npd-app-block .jdgm-prev-badge');
    if (starWidget) {
      var starBlock = starWidget.closest('.npd-app-block');
      if (starBlock) {
        if (ratingSlot.querySelector('.npd-stars')) {
          starBlock.remove();
        } else {
          starBlock.classList.add('npd-stars-app');
          ratingSlot.appendChild(starBlock);
        }
      }
    }
  }

  // ── Fit-quiz (EasySize) → inline beside the model note ──
  // EasySize injects a #easysize_button div into the info column
  // asynchronously (outside its app block), so watch for it and re-home it.
  var modelNote = root.querySelector('.npd-model-note');
  function homeFitQuiz() {
    if (!modelNote) return;
    var btn = document.getElementById('easysize_button');
    if (btn && !modelNote.contains(btn)) {
      btn.classList.add('npd-fitquiz-inline');
      modelNote.appendChild(btn);
      // EasySize's default label leads with an en dash — the design doesn't
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        node.textContent = node.textContent.replace(/^\s*[–-]\s*/, '');
      }
    }
    var fitQuiz = root.querySelector('.npd-app-block .fit-quiz-wrapper, .npd-app-block .easysize-container');
    if (fitQuiz) {
      var fitBlock = fitQuiz.closest('.npd-app-block');
      if (fitBlock && !modelNote.contains(fitBlock)) {
        fitBlock.classList.add('npd-fitquiz-inline');
        modelNote.appendChild(fitBlock);
      }
    }
  }
  function collapseEmptyAppBlocks() {
    // zero-height app blocks (e.g. countdown with no active campaign) keep
    // their 22px margin and hold the CTA cluster apart — zero it while empty
    root.querySelectorAll('.npd-app-block').forEach(function (b) {
      var visible = [...b.children].some(function (c) { return c.offsetHeight > 0; });
      b.style.marginBottom = visible ? '' : '0px';
    });
  }

  function collapseEmptyNote() {
    if (!modelNote) return;
    // scripts inside don't count as content — hide the row when the fit-quiz
    // link isn't actually visible, closing the gap the old text left behind
    var visible = [...modelNote.children].some(function (c) {
      return c.tagName !== 'SCRIPT' && c.offsetHeight > 0;
    });
    modelNote.style.display = visible ? '' : 'none';
  }
  homeFitQuiz();
  collapseEmptyNote();
  collapseEmptyAppBlocks();
  if (modelNote && window.MutationObserver) {
    new MutationObserver(function () { homeFitQuiz(); collapseEmptyNote(); collapseEmptyAppBlocks(); }).observe(root, { childList: true, subtree: true, attributes: true });
  }

  // ── Reviews anchor: scroll to the reviews section (custom nrv section
  // first, Judge.me widget as fallback) ──
  // every .npd-reviews-link scrolls (head rating + the accordion A2 row)
  root.querySelectorAll('.npd-reviews-link').forEach(function (reviewsLink) {
    reviewsLink.addEventListener('click', function (e) {
      var target = document.querySelector('#reviews, .nrv-section, .jdgm-rev-widg, .jdgm-widget.jdgm-review-widget');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  updateUI();
})();
